import { ApolloProvider } from '@apollo/client';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from '@sentry/react';
import { BrowserRouter } from 'react-router';
import { Global } from '@emotion/react';
import { App as AntdApp } from 'antd';
import * as serviceWorker from './serviceWorker';
import { i18n } from './lib/i18n';
import { App } from './App';
import { handleServiceWorkerUpdate } from './lib/handleServiceWorkerUpdate';
import { sentrySetup } from './lib/sentry';
import apolloClientSetup from './lib/apollo';
import { globalStyles } from './lib/styles';
import { ThemeAndConfigProvider } from './provider/ThemeAndConfigProvider';
import { ErrorFallbackPage } from './pages/ErrorFallback';

sentrySetup();
const container = document.getElementById('root');
const root = createRoot(container!);
await i18n;
const client = await apolloClientSetup();

root.render(
  <ApolloProvider client={client}>
    <ThemeAndConfigProvider>
      <BrowserRouter>
        <Global styles={globalStyles} />

        <AntdApp
          css={{
            height: '100%',
            minHeight: '100%',
          }}
        >
          <ErrorBoundary fallback={() => <ErrorFallbackPage />}>
            <App />
          </ErrorBoundary>
        </AntdApp>
      </BrowserRouter>
    </ThemeAndConfigProvider>
  </ApolloProvider>,
);

serviceWorker.register({ onUpdate: handleServiceWorkerUpdate });
